import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=27d0a8da&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=27d0a8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d0a8da",
  null
  
)

export default component.exports